import Skeleton from "@mui/material/Skeleton";

export default Skeleton;
